import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Stairs.svg",
  "use": "Stairs.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Stairs.svg\"><path d=\"M54,52H10a2,2,0,0,1-2-2V44a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V34a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V24a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V14a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2V50A2,2,0,0,1,54,52Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol